import { Tabs, Tab } from "@mui/material";
import { colors, typography } from "../../../../assets/styles/tokens";

interface LeadsManagementMobileTabsProps {
  view: "leads" | "analytics";
  onChangeView: (view: "leads" | "analytics") => void;
}

// Mobile-only variant of LeadsManagementTabs — kept separate rather than
// restyling the shared desktop component, since these design-token colors
// (border-brand_alt/bg-brand-primary) are specific to the mobile screenshot
// and shouldn't change the desktop LEADS/ANALYTICS tabs.
export default function LeadsManagementMobileTabs({ view, onChangeView }: LeadsManagementMobileTabsProps) {
  return (
    <Tabs
      value={view}
      onChange={(_, value) => onChangeView(value)}
      variant="fullWidth"
      sx={{
        borderBottom: `1px solid ${colors.GrayLightMode[200].$value}`,
        minHeight: 0,
        "& .MuiTab-root": {
          minHeight: 0,
          fontFamily: typography.Font_Family.$value,
          fontWeight: typography.Font_weight.Medium.$value,
          fontSize: typography.Size.Text.sm.$value,
          lineHeight: typography.Line_height.text.sm.$value,
          letterSpacing: "0%",
          textTransform: "uppercase",
          color: colors.GrayLightMode[500].$value,
        },
        "& .Mui-selected": { color: `${colors.GrayLightMode[900].$value} !important` },
        "& .MuiTabs-indicator": { backgroundColor: colors.Brand[600].$value, height: 2 },
      }}
    >
      <Tab value="leads" label="Leads" />
      <Tab value="analytics" label="Analytics" />
    </Tabs>
  );
}
